import React, { Component, Fragment } from "react";
import styled from "@emotion/styled";
import { ReactComponent as CloseCircle } from "Icons/CloseCircle.svg";
import { Spacer } from "../Spacer/index";
export default class ModalT1 extends Component {
  render() {
    const { isOpenState, handleOnClickForClose, children } = this.props;
    return (
      <Fragment>
        {!!isOpenState && (
          <Fragment>
            <ModalContainer>
              <ModalBox>
                <CloseWrapper>
                  <CloseBtn onClick={handleOnClickForClose}>
                    <CloseCircle
                      fill={"#ffffff"}
                      style={{ width: "32px", cursor: "pointer" }}
                    />
                  </CloseBtn>
                </CloseWrapper>
                <Spacer spacing={"2px"} />
                <ModalT1Content>{children}</ModalT1Content>
              </ModalBox>
            </ModalContainer>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
`;

const ModalBox = styled.div`
  position: absolute;
  width: 100%;
  max-width: 90%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const CloseWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ModalT1Content = styled.div`
  overflow: auto;
  height: 70vh;
`;

const CloseBtn = styled.button`
  all: unset;
  margin: 0px;
  padding: 0px;
  height: fit-content;
  max-height: 32px;
  cursor: pointer;
  &:hover > svg {
    fill: #558ce7;
  }
  &:active > svg {
    transform: scale(0.95);
  }
`;
